<template>
    <div class="shop-import">
        <ul class="shop-import__tips fs-12 lh-20 p-8 color-333">
            <li>1.仅限从森果老零售店铺导入。</li>
            <li>2.导入信息包括：会员微信昵称、真实姓名、手机号、生日、余额、积分、会员卡号、会员密码。</li>
            <li>3.会员数据导入并不意味店铺之间数据互通，导入后两店铺会员消费仍相互独立，会员数据不会互相影响。</li>
            <li>4.会员手机号在店铺内具有唯一性，如遇导入的新会员手机号与店铺原会员手机号重复，则会将信息进行合并，您可以自主选择覆盖规则。</li>
        </ul>
        <!-- 还未选择过店铺 -->
        <el-button v-if="!isHasSelect"
            :class="['shop-import__select', { disabled: $store.state.shop.isImportingMemberData }]"
            type="primary"
            size="medium"
            :disabled="$store.state.shop.isImportingMemberData"
            @click="openShopImportProcess">
            <img src="../images/shop_small.svg" alt="shop-logo">
            选择店铺
            <i class="el-icon-arrow-right" />
        </el-button>
        <!-- 选择过店铺 -->
        <template v-else>
            <el-button :class="['shop-import__selected', { disabled: $store.state.shop.isImportingMemberData }]"
                type="default"
                size="medium"
                :disabled="$store.state.shop.isImportingMemberData"
                @click="openShopImportProcess">
                <img src="../images/shop_small_333.svg" alt="shop-logo">
                <!-- <span class="shop-import__selected-prev">门店零售</span> -->
                <img class="shop-import__selected-prev" src="../images/old_ls_shop_icon.svg" alt="">
                <span class="shop-import__selected-mid text-popper" v-textPopper>{{ lsShopInfo.shop_name }}</span>
                <i class="el-icon-arrow-right" />
            </el-button>
            <begin-import :lsShopInfo="lsShopInfo"
                @import-success="isHasSelect = false" />
        </template>
        <!-- components -->
        <shop-import-process :visible.sync="isShowShopImportProcess"
            @confirm="selectShopConfirm" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, computed, onBeforeMount, onMounted } from '@vue/composition-api'
import ShopImportProcess, { IOldShopInfo } from '../components/shop_import_process.vue'
import BeginImport from '../components/begin_import.vue'
import { openMessage } from '../../../../utils/system'
import $fetch from '../../../../api'
import clone from 'lodash/cloneDeep'

interface ILsShopInfo {
    ls_shop_id: number | string
    shop_name: string
}

export default createComponent({
    setup: (props, ctx) => {
        const isShowShopImportProcess = ref(false)
        const isHasSelect = ref(false)
        const lsShopInfo = ref<ILsShopInfo>({})

        onBeforeMount(() => {
            if (ctx.root.$store.state.isImportingMemberData) {
                // 正在导入...
                lsShopInfo.value = ctx.root.$store.state.oldLsShopInfo
                isHasSelect.value = true
            }
        })

        function openShopImportProcess() {
            isShowShopImportProcess.value = true
        }

        function selectShopConfirm(oldShopInfo: IOldShopInfo) {
            lsShopInfo.value = {
                ls_shop_id: oldShopInfo.old_ls_shop_id,
                shop_name: oldShopInfo.shop_name
            }
            isHasSelect.value = true
        }

        return {
            // data
            isShowShopImportProcess,
            isHasSelect,
            lsShopInfo,
            // methods
            openShopImportProcess,
            selectShopConfirm
        }
    },

    components: {
        ShopImportProcess,
        BeginImport
    }
})
</script>

<style lang="scss" scoped>
.shop-import {
    &__tips {
        background-color: #f7f7f7;
    }

    &__select,
    &__selected {
        width: auto;
        padding: 8px;
        margin-top: 12px;

        ::v-deep > span {
            display: flex;
            align-items: center;
            height: 20px;

            img:first-child {
                width: 18px;
                height: 18px;
                margin-right: 5px;
            }

            i {
                margin-left: 2px;
                font-size: 18px;
            }
        }
    }

    &__select {
        width: 112px;
    }

    &__selected {
        text-align: left;
        font-weight: normal;
        background-color: #fff !important;
        border-color: #DCDFE6 !important;
        color: #333 !important;

        &:hover {
            background-color: #f7f7f7 !important;
        }

        &:active {
            background-color: #ddd !important;
        }

        img:first-child {
            margin-right: 0 !important;
        }

        &-prev {
            margin: 0 10px 0;
            font-size: 12px;
            background-color: #E7F9F5;
            color: #14CC9B;
        }

        &-mid {
            width: auto;
            max-width: 160px;
        }
    }
}
</style>
